module.exports = __webpack_public_path__ + "14e23746940f7b21f86fd00e8b216115.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/holdings-list.png
// module id = 1756
// module chunks = 0